import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";

function CoachGradeBulkBar({
  selectedCount = 0,
  belts = [],
  form,
  saving,
  onChange,
  onSubmit,
  onClear,
}) {
  if (!selectedCount) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] border-t border-slate-200 bg-white/95 px-3 py-3 shadow-2xl shadow-slate-950/20 backdrop-blur-xl dark:border-white/10 dark:bg-slate-950/95">
      <form
        onSubmit={onSubmit}
        className="mx-auto flex w-full max-w-[1280px] flex-col gap-3 lg:flex-row lg:items-center"
      >
        <div className="rounded-2xl bg-blue-50 px-4 py-3 text-sm font-bold text-blue-800 dark:bg-sky-500/10 dark:text-sky-200 lg:min-w-[230px]">
          {selectedCount} judoka{selectedCount > 1 ? "s" : ""} sélectionné
          {selectedCount > 1 ? "s" : ""}
        </div>

        <select
          name="belt_id"
          value={form.belt_id}
          onChange={onChange}
          className="h-12 flex-1 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-900 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10"
        >
          <option value="">Sélectionner une ceinture</option>

          {belts.map((belt) => (
            <option key={belt.id} value={belt.id}>
              {belt.nom}
            </option>
          ))}
        </select>

        <input
          type="date"
          name="date_passage"
          value={form.date_passage}
          onChange={onChange}
          className="h-12 rounded-2xl border border-slate-200 bg-slate-50 px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-sky-300 focus:bg-white focus:ring-4 focus:ring-sky-100 dark:border-white/10 dark:bg-slate-900 dark:text-white dark:focus:border-sky-300/50 dark:focus:ring-sky-500/10 lg:w-[210px]"
        />

        <div className="grid grid-cols-2 gap-2 lg:flex">
          <button
            type="button"
            onClick={onClear}
            disabled={saving}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:border-red-200 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
          >
            <FaTimes />
            Annuler
          </button>

          <button
            type="submit"
            disabled={saving}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-blue-700 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
          >
            <FaCheck />
            {saving ? "Validation..." : "Valider passage"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CoachGradeBulkBar;